import { getTokenService } from '@/services/token';
import { useAuthInterface } from '@/composables/useAuthInterface';
import { Capacitor } from '@capacitor/core';
import { useCapacitorPreferences } from '@/composables/capacitor/useCapacitorPreferences.ts';

export const AuthVuexPlugin = store => {
  store.$log('AuthVuexPlugin', 'begin init');
  const tokenService = getTokenService();
  const token = tokenService.getAccessToken();

  if (token) {
    store.$log('AuthVuexPlugin', 'valid token found, setting up');
    store.commit('auth/setIsBusy', true);
    store.commit('auth/setAccessToken', token);
    store.commit('auth/setRefreshToken', tokenService.getRefreshToken());
    store.commit('general/setSendAuthorizationHeader', true);

    store.$authReady = store
      .dispatch('auth/fetchUser', true)
      .then(user => {
        if (!user) {
          return;
        }
        store.commit('auth/setIsLoggedIn', true);

        if (!store.state.general.isMobileApp) {
          store.dispatch('auth/refreshTokens').then(() => {
            tokenService.startPolling({
              onExpirySoon: () => store.dispatch('auth/refreshTokens'),
              onTokenMissing: () => {
                // auth/logout now handles its own redirect via useLogoutRedirect.
                store.dispatch('auth/logout');
              }
            });
          });
        }
      })
      .catch(() => {});
  } else {
    store.$log('AuthVuexPlugin', 'no valid token found', 'W');
    tokenService.clearTokens();
    store.commit('auth/setAccessToken', undefined);
    store.commit('auth/setRefreshToken', undefined);

    if (Capacitor.isNativePlatform()) {
      useCapacitorPreferences().resetPreferenceStore();
    }

    store.$authReady = Promise.resolve();
  }

  // Legacy localStorage cleanup
  ['auth._token', 'auth._token_expiration', 'auth._refresh_token', 'accessTokenExpiresAt'].forEach(
    key => localStorage.removeItem(key)
  );

  store.$log('AuthVuexPlugin', 'init done', 'S');

  store.$auth = useAuthInterface(store);
};
